// extracted by mini-css-extract-plugin
export default {"ldsRing":"styles_ldsRing__fDjbe"};